"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { makeDataField } from '../../../../DataBuilder/index.mjs';
import { useFormComponents } from '../../../../DataBuilder/use-form-components.mjs';
import { SvgIcon } from '../../../../SvgIcon/index.mjs';
import { SvgIconType } from '../../../../SvgIcon/svg-icon-type.mjs';
import { withSlotScopeClasses } from '../../../../../helpers/scoped-slots.mjs';
import { toHeaderCase } from 'js-convert-case';
import { useState } from 'react';
import { tv } from 'tailwind-variants';
import { Button } from '../../../../../ui-kit/button.mjs';
import { Icon } from '../../../../../ui-kit/icon.mjs';
import { PanelHeader, PanelHeaderButton, NoParameters, ParametersList, Parameter, ParameterText } from './UiComponents.mjs';

const parametersConfigRecipe = tv({
  slots: withSlotScopeClasses("lookup-parameters-config", {
    container: "flex flex-col p-1.5 pb-2.5 gap-2",
    "save-button": "w-fit h-fit rounded-xl text-slate-11 px-2 py-1"
  })
});
function ParametersPanel({
  onChange,
  schema,
  value,
  className
}) {
  const parametersProvided = isParametersProvided(value);
  const [isEditing, setIsEditing] = useState(!parametersProvided);
  const { container } = parametersConfigRecipe();
  function isParametersProvided(object) {
    return !!Object.keys(object).length;
  }
  function toggleIsEditing() {
    setIsEditing(!isEditing);
  }
  function handleOnClose() {
    setIsEditing(false);
  }
  return /* @__PURE__ */ jsxs("div", { className: container({ className }), children: [
    /* @__PURE__ */ jsx(
      PanelHeader,
      {
        title: "Parameters",
        actions: /* @__PURE__ */ jsx(EditParametersButton, { onClick: toggleIsEditing, isEditing })
      }
    ),
    isEditing ? /* @__PURE__ */ jsx(ParametersPanelForm, { onChange, onClose: handleOnClose, schema, value }) : /* @__PURE__ */ jsx(ParametersPanelView, { schema, value })
  ] });
}
function ParametersPanelForm({
  onClose,
  onChange,
  schema,
  value
}) {
  const { DataBuilderForm } = useFormComponents();
  const styles = parametersConfigRecipe();
  const field = makeDataField({
    schema,
    value
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DataBuilderForm, { field, onChange }),
    /* @__PURE__ */ jsx(Button, { onClick: onClose, variant: "outline", colorPalette: "gray", size: "sm", className: styles["save-button"](), children: "Save and Close" })
  ] });
}
function ParametersPanelView({ schema, value }) {
  const parameters = Object.entries(schema?.properties ?? {}).map(([key, field]) => {
    return {
      key,
      title: field?.title || toHeaderCase(key),
      value: value?.[key]
    };
  });
  if (!parameters.length) {
    return /* @__PURE__ */ jsx(NoParameters, {});
  }
  return /* @__PURE__ */ jsx(ParametersList, { children: parameters.map(({ key, title, value: value2 }) => /* @__PURE__ */ jsx(Parameter, { children: /* @__PURE__ */ jsx(ParameterText, { title, value: value2 }) }, key)) });
}
function EditParametersButton({ onClick, isEditing }) {
  const label = isEditing ? "Cancel" : "Edit";
  const icon = isEditing ? SvgIconType.Close : SvgIconType.Edit;
  return /* @__PURE__ */ jsxs(PanelHeaderButton, { onClick, children: [
    label,
    /* @__PURE__ */ jsx(Icon, { children: /* @__PURE__ */ jsx(SvgIcon, { type: icon }) })
  ] });
}

export { ParametersPanel };
